import { LocationInformation } from "types/locationInformation";

export function hasMissingRequiredSiteInformation(siteInformation: LocationInformation) {
  return (
    !siteInformation.buildingAccessHoursOption ||
    !siteInformation.coiRequiredOption ||
    !siteInformation.freightElevatorNotesOption ||
    !siteInformation.loadingDockHeightOption ||
    !siteInformation.loadingZoneOption ||
    siteInformation.timeLimitLoadingZoneMinutes === null ||
    siteInformation.timeLimitLoadingZoneMinutes === undefined
  );
}
